import store from '../../../Store';
/* eslint-disable import/prefer-default-export */

export const getVisitorName = () => {
  const { generalInfo } = store.getState().visitorContext;
  return generalInfo?.visitorName || '';
};
